export default __webpack_public_path__ + "bea6896e373a04efa6e5937e974a6254.svg";